/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React, { useEffect, useState } from 'react';
import { useQueryParams, ArrayParam, StringParam } from 'use-query-params';
import CompanyNavBar, { navLinks } from '../../components/CompanyNavBar';
import unlockProfile from '../../lib/api/unlockProfile';
import { useAuth } from '../../commons/Auth';
import HumanResourcesFilters from '../../components/HumanResources/HumanResourcesFilters';
import { THumanResourcesFilters } from '../../components/HumanResources/human-resources';
import HumanResourcesList from '../../components/HumanResources/HumanResourcesList';
import useHumanResources from '../../lib/hooks/useHumanResources';
import useHumanResourceMutation from '../../lib/hooks/useHumanResourceMutation';
import useMe from '../../lib/hooks/useMe';
import FullScreenSpinner from '../../components/FullScreenSpinner';
import saveFavourite from '../../lib/api/saveFavourite';

const UnlockedProfiles: React.FC = function UnlockedProfiles() {
  const { token }: any = useAuth();
  const [query, setQuery] = useQueryParams({
    bucket: StringParam,
    luogoLavoro: StringParam,
    eta: StringParam,
    residenza: StringParam,
    occupazione: StringParam,
    automunito: StringParam,
    titoloStudio: StringParam,
    esperienza: StringParam,
    mobilita: StringParam,
    incentivi: StringParam,
    qualifica: StringParam,
    settori: ArrayParam,
    aree_di_competenza: ArrayParam,
    categoriaProtetta: StringParam,
  });

  useMe(token);
  const { data: users, isLoading } = useHumanResources({ ...query, unlocked: true }, token);
  const { mutate: mutateUnlockeds, isLoading: isLoadingUnlock } = useHumanResourceMutation(unlockProfile);
  const { mutate: mutateFavourite } = useHumanResourceMutation(saveFavourite);

  const [filters, setFilters] = useState<THumanResourcesFilters>({ ...query });
  useEffect(() => setFilters({ ...query }), [query]);

  useEffect(() => {
    if (users) users.sort((a, b) => new Date(b.data_sblocco!).getTime() - new Date(a.data_sblocco!).getTime());
  }, [users]);

  return (
    <div>
      <CompanyNavBar navLink={navLinks.unlockedProfiles} />
      <div>
        <HumanResourcesFilters filters={filters} onFilter={setQuery} />
        {(isLoading || isLoadingUnlock) && <FullScreenSpinner />}
        {!isLoading && !isLoadingUnlock && users && users.length > 0 ? (
          <HumanResourcesList
            users={users}
            onUnlock={(data: any) => mutateUnlockeds({ ...data, token })}
            onFavourite={(data: any) => mutateFavourite({ ...data, token })}
          />
        ) : (
          <div className="text-center mt-36">
            <h1>Nessun utente trovato</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnlockedProfiles;